import { Fragment } from "react";
import { FiltersProvider } from "../../../../../components/providers/FiltersProvider";
import PickupStatusHistory from "./PickupStatusHistory";

const PickupStatusHistoryWrapper = () => {
    const defaultFilters = {};

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PickupStatusHistory />
            </FiltersProvider>
        </Fragment>
    );
};

export default PickupStatusHistoryWrapper;